import { Link } from "@StarberryUtils";
import React, { useState, useEffect } from "react"
import {Button, Form, Container, Row, Col,Dropdown} from 'react-bootstrap';
import "./FilterBlock.scss"
// markup
const FilterBlock = (props) => {
  
  const [arrow, setArrow] = useState(false);
  const [input, setInput] = useState(false);
  const [filter, setFilter] = useState(false);
  const [filterOpen, setfilterOpen] = useState(false);

  const filterRefine =()=>{
    setFilter(!filter)
  }

  const inputClick=()=>{
    setInput(!input)
  }

  const arrowClick=()=>{
    setArrow(!arrow)
  }
  const filterClick=()=>{
    setfilterOpen(!filterOpen)
  }
    return (
        <React.Fragment>
             <section className="filter">
               <div className="filter-field">
      <Container>
        <Row>
          <Col className="filter-fixed ">
            <Form className="form-data">
              <div className="search-box">
                <Form.Control type="search" placeholder="Street, area or postcode" />
                <i className="icon-search">
                </i>
              </div>
              <div className={filterOpen ? "filter-mobile_btn d-lg-none filter-up": "filter-mobile_btn d-lg-none"} onClick={filterClick}>
                  <span>Filter</span>
                  <i className="icon-down"></i>
              </div>
              <div className={filterOpen ? "box-wrapper d-xl-flex d-block" : "box-wrapper d-xl-flex"}>
              <div className="select-boxes select-boxes-buy">
              <Dropdown>
                  <Dropdown.Toggle variant="link"> Buy</Dropdown.Toggle>
                  
                   <Dropdown.Menu>
                  <Dropdown.Item>Bed 1</Dropdown.Item>
                  <Dropdown.Item >Bed 2</Dropdown.Item>
                  <Dropdown.Item>Bed 3</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
                </div>
                <div className="select-boxes">
                <Dropdown>
                  <Dropdown.Toggle variant="link"> Min Price</Dropdown.Toggle>
                  <Dropdown.Menu>
                  <Dropdown.Item>£10,000</Dropdown.Item>
                  <Dropdown.Item >£20,000</Dropdown.Item>
                  <Dropdown.Item>£30,000</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
                </div>
                <div className="select-boxes">
                    <Dropdown>
                      <Dropdown.Toggle variant="link"> Max Price</Dropdown.Toggle>
                      <Dropdown.Menu>
                      <Dropdown.Item>£90,000</Dropdown.Item>
                      <Dropdown.Item >£100,000</Dropdown.Item>
                      <Dropdown.Item>£200,000</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
             
                <div className="select-boxes">
                <Dropdown>
                      <Dropdown.Toggle variant="link"> Property Type</Dropdown.Toggle>
                      <Dropdown.Menu>
                      <Dropdown.Item>Bed 1</Dropdown.Item>
                      <Dropdown.Item >Bed 2</Dropdown.Item>
                      <Dropdown.Item>Bed 3</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
              
                </div>
              </div>

            </Form>
          </Col>
        </Row>
        </Container>
        </div>
        <Container>
        <Row>
            <Col>
            <div className="search-result-short">

        <div className="search-result-title">

        <h2><strong>48</strong>  Properties for sale in Shrewsbury</h2>
        <i className="icon-info"></i>
        </div>
        <div className="filter-short">
        <div className="switch-button map-btn-wrap" onClick={()=>props.showMapFn()}>
                  <label for="map-button">
                    <span className={props.show ? "toggle-switch map-toggle" : "toggle-switch"}>
                      <span className="toggle-switch-bar"></span>
                    </span>
                    <span className="toggle-text">Map Off</span>
                  </label>
          </div>

        <div className="switch-button ">
                  <label for="toggle-button">
                    <input type="checkbox" onClick={inputClick} id="toggle-button" checked={input ? "" : "checked"} />
                    <span className="toggle-switch">
                      <span className="toggle-switch-bar"></span>
                    </span>
                    <span className="toggle-text">Include Sold</span>
                  </label>
          </div>
          <div className="price-short-filter" onClick={arrowClick}>
            <i className={arrow ? "short-icon short-icon-low" : "short-icon"}></i>
            <span className="toggle-text d-none d-md-block">{arrow ? " Lowest" : " Highest"} Price First</span>
            <span className="toggle-text d-md-none">{arrow ? " Lowest" : " Highest"}</span>
          </div>

        </div>
      </div>
            </Col>
        </Row>
       
      </Container>
    </section>
        </React.Fragment>
    )
}
export default FilterBlock